import * as z from 'zod';

export const shirtSizePreferenceQuerySchema = z.enum(['x-small', 'small', 'medium', 'large', 'x-large', 'xx-large']);

type TShirtSizePreferenceQuerySchema = z.infer<typeof shirtSizePreferenceQuerySchema>;
export type ShirtSizePreferenceMutationSchema = TShirtSizePreferenceQuerySchema;

export const shirtSizePreferenceFormSchema = z.object({
  name: z.string(),
  value: shirtSizePreferenceQuerySchema,
});

export type ShirtSizePreferenceFormSchema = z.infer<typeof shirtSizePreferenceFormSchema>;

export const defaultShirtSizePreference = null;

export const shirtSizePreferenceOptions: ShirtSizePreferenceFormSchema[] = [
  { name: 'X-Small', value: 'x-small' },
  { name: 'Small', value: 'small' },
  { name: 'Medium', value: 'medium' },
  { name: 'Large', value: 'large' },
  { name: 'X-Large', value: 'x-large' },
  { name: 'XX-Large', value: 'xx-large' },
];

export function strToShirtSizePreference(
  shirtSizePreference?: TShirtSizePreferenceQuerySchema | null
): ShirtSizePreferenceFormSchema | null {
  return shirtSizePreferenceOptions.find((option) => option?.value === shirtSizePreference) ?? null;
}

export function shirtSizePreferenceToStr(shirtSizePreference: ShirtSizePreferenceFormSchema | null) {
  return shirtSizePreference?.value ?? null;
}
